import axios from 'axios';
 

export const getFooter = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}footer`); 
    return response.data;
  } catch (error) {
    console.error('Error fetching Footer:', error);
    throw error;
  }
};
